var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrettyspaces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.50003,
    y: 1.5,
    width: 51,
    height: 51.051,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.24487,
    width: 51.5,
    height: 51.551,
    rx: 5.75,
    fill: "#BDD1EE",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 27.6199L26.375 5.74487L4.5 27.6199L26.375 49.4949L48.25 27.6199ZM30.5749 43.0895L27.4777 39.9923L42.9474 24.5227L46.0425 27.6199L30.5749 43.0895ZM33.8345 23.8099L31.1273 26.5171L23.6675 19.0574L26.3747 16.3501L33.8345 23.8099ZM30.185 35.0796L27.4777 32.3724L34.9375 24.9127L37.6447 27.6199L30.185 35.0796ZM30.0225 27.6199L26.3749 31.2694L22.7274 27.6199L26.3749 23.9723L30.0225 27.6199ZM22.5648 20.1601L25.272 22.8673L17.8122 30.3271L15.105 27.6199L22.5648 20.1601ZM21.6245 28.7226L29.0842 36.1824L26.375 38.8896L18.9152 31.4298L21.6245 28.7226ZM41.8446 23.42L38.7474 26.5171L23.2778 11.0475L26.3749 7.95239L41.8446 23.42ZM22.1751 12.1503L25.2722 15.2474L9.80258 30.717L6.70746 27.6199L22.1751 12.1503ZM26.375 47.2873L10.9054 31.8198L14.0025 28.7226L29.4721 44.1922L26.375 47.2873Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrettyspaces);
export default __webpack_public_path__ + "static/media/prettyspaces.f8c42cbda3a7fd2dc27459edc115f6d9.svg";
export { ForwardRef as ReactComponent };